import { render, staticRenderFns } from "./LixeiraCaptacao.vue?vue&type=template&id=2ea2880d&scoped=true&"
import script from "./LixeiraCaptacao.vue?vue&type=script&lang=js&"
export * from "./LixeiraCaptacao.vue?vue&type=script&lang=js&"
import style0 from "./LixeiraCaptacao.vue?vue&type=style&index=0&id=2ea2880d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea2880d",
  null
  
)

export default component.exports